import { TRIGGERS_PART01 } from './triggers.part01.js'
import { TRIGGERS_PART02 } from './triggers.part02.js'

/** Sample event-driven automations shown under Triggers › Mine. */
export const DEMO_TRIGGERS = [...TRIGGERS_PART01, ...TRIGGERS_PART02]
